(function($) {$(document).ready(function() {

	let prevScrollState = 'top'; // top || scrolled

	// Mobile
	if (window.innerWidth < 1200) {
		$('.m-header-bar__menu-btn').on('click', toggleMobileMenu);
		$('.main-menu__link.has-sub-menu > a').on('click', openMobileSubMenu);
		$('.header__m-back').on('click', gotoMobileMenuPart1);
		$('.header__m-close').on('click', mobileMenuClose);
		$('.m-header-bar__search-btn').on('click', openMobileSearch);
		$('.m-search-box__close').on('click', closeMobileSearch);
		$(window).on('scroll', checkMobileScrollPosition);
		checkMobileScrollPosition();
	}

	// Desktop
	if (window.innerWidth >= 1200) {
		$('.main-menu__link.has-sub-menu > a').on('mouseenter', openDesktopSubMenu);
		$('.main-menu__sub-menu').on('mouseleave', closeDesktopSubMenu);
		$('.header__logo, .d-top-menu, .main-menu__link:not(.has-sub-menu)').on('mouseenter', closeDesktopSubMenu);
	}

	function toggleMobileMenu(event) {
		$('body').toggleClass('m-menu-open');
	}

	function openMobileSubMenu(event) {
		event.preventDefault();

		if (window.innerWidth >= 1200) return;

		const $this = $(this);

		// Make sub menu visible
		$this
			.siblings('.main-menu__sub-menu')
			.addClass('m-show');

		// move to sub menu
		$('.header__inner').addClass('m-pt2');
	}

	function gotoMobileMenuPart1() {
		$('.header__inner').removeClass('m-pt2');
		$('.main-menu__sub-menu.m-show').removeClass('m-show');
	}

	function mobileMenuClose() {
		gotoMobileMenuPart1();
		$('body').removeClass('m-menu-open');
	}

	function openMobileSearch() {
		$('.m-search-box').addClass('open');
	}

	function closeMobileSearch() {
		$('.m-search-box').removeClass('open');
	}

	function checkMobileScrollPosition(event) {
		if (window.scrollY > 50 && prevScrollState !== 'scrolled') {
			$('.header').addClass('scrolled');
			prevScrollState = 'scrolled';
		} else if (window.scrollY <=50 && prevScrollState !== 'top') {
			$('.header').removeClass('scrolled');
			prevScrollState = 'top';
		}
	}



	function openDesktopSubMenu(event) {
		const $this = $(this);

		$('.header').addClass('d-sub-menu-open');

		$this
			.parent()
			.addClass('d-open')
			.siblings()
			.removeClass('d-open');
	}

	function closeDesktopSubMenu(event) {
		$('.header').removeClass('d-sub-menu-open');
		$('.main-menu__link.d-open').removeClass('d-open');
	}

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);